import {get, omit, split, upperCase} from 'lodash';
import qs from 'qs';
import {CustomParamsSerializer} from 'axios';

type SerializeParams = Parameters<CustomParamsSerializer>[0];

export const serialize = (params: SerializeParams): string => {
  const rest = omit(params, 'order');
  const [field, sort] = split(get(params, 'order', ''), ',');
  return qs.stringify({...rest, order: [field, upperCase(sort)]}, {arrayFormat: 'repeat'});
};
